/**
 * Module dependencies.
 */

import { FilterRange } from 'src/types/model-ranges';
import { ReactElement } from 'react';
import { modelRangeSpecsMeasures } from 'src/core/content-config/model-ranges';
import BaseDisclosure from './base-disclosure';
import FilterItem from 'src/components/filters/filter-item';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import useTranslate from 'src/hooks/use-translate';

/**
 * `Props` type.
 */

type Props = {
  filterName: string;
  rangesList?: FilterRange[];
};

/**
 * `BaseFilter` component.
 */

const BaseFilter = ({ filterName, rangesList }: Props): ReactElement => {
  const { translate } = useTranslate();

  if (isEmpty(rangesList)) {
    return null;
  }

  return (
    <BaseDisclosure
      measure={modelRangeSpecsMeasures[filterName]}
      title={translate(`common:labels.${filterName}`)}
    >
      {map(rangesList, ({ from, key, to }) => {
        const label = `${from} - ${to} ${modelRangeSpecsMeasures[filterName]}`;

        return (
          <FilterItem
            key={key}
            label={label}
            name={filterName}
            value={{ from, key, to }}
          />
        );
      })}
    </BaseDisclosure>
  );
};

/**
 * Export `BaseFilter` component.
 */

export default BaseFilter;
